import { Button, useIsDesktop } from '@kanda-libs/ks-design-library';
import useBookCallButton from './useBookCallButton';

const BookCallButton: React.FunctionComponent = function () {
  const isDesktop = useIsDesktop();
  const { url } = useBookCallButton();
  return (
    <a href={url} target="_blank" rel="noreferrer">
      <Button.Text
        id="setup-book-callback"
        variant="solid"
        size={isDesktop ? 48 : 40}
        label="Book a call back"
        icon="phone"
        left
      />
    </a>
  );
};

export default BookCallButton;
